unit unit_AenderungUSTID;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, DB;

type
  TAenderungUSTID = class(TForm)
    TC: TTableControl;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    WClient: TXDataWebClient;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnAbsenden:TButton;
    buttonzurueck:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularErstellen;

  protected procedure LoadDFMValues; override; end;

var
  AenderungUSTID: TAenderungUSTID;
  edtUSTIDNeu:TEdit;
implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TAenderungUSTID.btnAbsendenclick(Sender:TObject);
begin
  if edtUSTIDNeu.Text=xdsKundendatenUmsatzsteuerID.asstring then
  begin
    showmessage('Sie haben keine Änderung vorgenommen');
    exit;
  end;

  dm2.xdsProtokoll.Append;
  dm2.xdsProtokollDatum.AsDateTime:=date+time;
  dm2.xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
  dm2.xdsProtokollPruefungErforderlich.AsBoolean:=true;
  dm2.xdsProtokollNotiz.AsString:='USTID geändert, bisher '+xdsKundendatenUmsatzsteuerID.AsString+' Prüfung MIAS vornehmen '+InternetIpAdresse;
  dm2.xdsProtokoll.Post;
  dm2.xdsProtokoll.ApplyUpdates;
  xdsKundendaten.Edit;
  xdsKundendatenUmsatzsteuerID.AsString:=edtUSTIDNeu.Text;
  xdsKundendatenUSTIDgeprueft.AsString:='';
  xdskundendaten.Post;
  xdskundendaten.ApplyUpdates;

end;

procedure TAenderungUSTID.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungUSTID.FormularErstellen;
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  TC.ColCount:=1;
  TC.RowCount:=6;
  TC.Cells[0,0]:='<h4>USTID ändern';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left m-1';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-info text-left m-1';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='speichern';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Kundennummer <br><b>'+xdsKundendatenKundennummer.asstring;
  inc(i);
  TC.Cells[0,i]:='Hier können Sie Ihre Umsatzsteueridentifikationsnummer (USTID) ändern/bekanntgeben.';
  inc(i);

  TC.Cells[0,i]:='Umsatzsteueridentifikationsnummer bisher <br><b>'+xdsKundendatenUmsatzsteuerID.AsString;



  inc(i);
  TC.Cells[0,i]:='Ihre Umsatzsteueridentifikationsnummer* <br>';
  myelement:=TC.CellElements[0,i];
  edtUSTIDNeu:=TEdit.Create(self);
  edtUSTIDNeu.ElementClassName:='form-control';
  edtUSTIDNeu.Width:=300;
  edtUSTIDNeu.HeightStyle:=ssAuto;
  edtUSTIDNeu.TextHint:='';
  edtUSTIDNeu.MaxLength:=20;
  edtUSTIDNeu.Text:='';
  edtUSTIDNeu.ParentElement:=myelement;




  edtUSTIDNeu.SetFocus;



end;

procedure TAenderungUSTID.WebFormShow(Sender: TObject);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TAenderungUSTID.xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

  if info.Records[0].Error='' then
  begin
    showmessage('Ihre Änderung der USTID wurde vorgemerkt. Prüfung via MIAS wird später vorgenommen.');
    close;
  end;

end;

procedure TAenderungUSTID.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  dm2.xdsProtokoll.Load;
  FormularErstellen;
end;



procedure TAenderungUSTID.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  WClient := TXDataWebClient.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  try
    Name := 'AenderungUSTID';
    Width := 158;
    Height := 245;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 157;
    TC.Height := 224;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 56;
    WClient.Top := 408;
  finally
    TC.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
  end;
end;

end.